(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tagGrid() {
      if (!document.getElementById('shop-all')) {
        var grid = document.querySelector('.main-collection');
        if (grid) grid.id = 'shop-all';
      }
    }
    if (document.readyState !== 'loading') tagGrid();
    else document.addEventListener('DOMContentLoaded', tagGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.dataset.bsInit) return;
      el.dataset.bsInit = '1';
      var design = window.Shopify && window.Shopify.designMode;
      var start = parseInt(el.dataset.start || '0', 10) * 1000;
      var end = parseInt(el.dataset.end || '0', 10) * 1000;
      var now = Date.now();

      // Second check in the browser, in case the page was cached before the promo started/ended
      if (!design && ((start && now < start) || (end && now > end))) { el.hidden = true; return; }

      var cd = el.querySelector('[data-bs-countdown]');
      if (cd && end) {
        var out = cd.querySelector('[data-bs-countdown-value]');
        var timer;
        var tick = function () {
          var ms = end - Date.now();
          if (ms <= 0) { clearInterval(timer); if (!design) el.hidden = true; return; }
          var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
          out.textContent = (d ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
        };
        timer = setInterval(tick, 1000);
        tick();
        cd.hidden = false;
      }

      var btn = el.querySelector('[data-bs-copy]');
      if (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-bs-copy');
          var label = btn.querySelector('[data-bs-copy-label]');
          var done = function () { label.textContent = 'Copied'; setTimeout(function () { label.textContent = 'Copy'; }, 2000); };
          if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done); }
          else {
            var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta);
            ta.select(); document.execCommand('copy'); ta.remove(); done();
          }
        });
      }
    }
    function run() { document.querySelectorAll('.bs-promo').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-seo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-bs-seo-toggle]').forEach(function (btn) {
        if (btn.dataset.bsInit) return;
        btn.dataset.bsInit = '1';
        btn.addEventListener('click', function () {
          var box = btn.closest('[data-bs-seo]');
          var open = box.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.querySelector('[data-more]').hidden = open;
          btn.querySelector('[data-less]').hidden = !open;
        });
      });
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-bar-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function init(el) {
      if (el.dataset.pcbInit) return;
      el.dataset.pcbInit = '1';
      var design = window.Shopify && window.Shopify.designMode;
      var start = parseInt(el.dataset.start || '0', 10) * 1000;
      var end = parseInt(el.dataset.end || '0', 10) * 1000;
      var teaser = el.dataset.before === 'teaser';
      var out = el.querySelector('[data-pcb-time]');
      var label = el.querySelector('[data-pcb-label]');
      var timer;
      function tick() {
        var now = Date.now();
        var before = start && now < start;
        // Second check in the browser, in case the page was cached before the promo started/ended
        if (!design && (!end || now >= end || (before && !teaser))) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        label.textContent = before ? el.dataset.labelBefore : el.dataset.labelLive;
        var t = Math.max(0, Math.floor(((before ? start : end) - now) / 1000));
        var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
        out.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      }
      tick();
      timer = setInterval(tick, 1000);
      var link = el.querySelector('[data-pcb-click]');
      if (link) link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'promo_countdown_click', promo_name: label.textContent, promo_item: 'countdown_bar' });
      });
    }
    function run() { document.querySelectorAll('section.pcb').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function init(el) {
      if (el.dataset.pcbInit) return;
      el.dataset.pcbInit = '1';
      var design = window.Shopify && window.Shopify.designMode;
      var start = parseInt(el.dataset.start || '0', 10) * 1000;
      var end = parseInt(el.dataset.end || '0', 10) * 1000;
      var teaser = el.dataset.before === 'teaser';
      var q = function (k) { return el.querySelector('[data-pcb-' + k + ']'); };
      var cells = { d: q('d'), h: q('h'), m: q('m'), s: q('s') }, dwrap = q('dwrap'), sr = q('sr');
      var label = el.querySelector('[data-pcb-label]');
      var timer;
      function tick() {
        var now = Date.now();
        var before = start && now < start;
        // Second check in the browser, in case the page was cached before the promo started/ended
        if (!design && (!end || now >= end || (before && !teaser))) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        label.textContent = before ? el.dataset.labelBefore : el.dataset.labelLive;
        var t = Math.max(0, Math.floor(((before ? start : end) - now) / 1000));
        var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
        cells.d.textContent = pad(d); cells.h.textContent = pad(h); cells.m.textContent = pad(m); cells.s.textContent = pad(s);
        dwrap.hidden = d === 0;
        if (s === 0 || !sr.dataset.set) { sr.textContent = d + ' days, ' + h + ' hours, ' + m + ' minutes'; sr.dataset.set = '1'; }
      }
      tick();
      timer = setInterval(tick, 1000);
      var link = el.querySelector('[data-pcb-click]');
      if (link) link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'promo_countdown_click', promo_name: label.textContent, promo_item: 'countdown_bar' });
      });
    }
    function run() { document.querySelectorAll('section.pcb').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-tire-reservation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REVISION = '2024-10-15';

    function init(root) {
      if (root.dataset.viprInit) return;
      root.dataset.viprInit = '1';

      var catalog = [];
      try { catalog = JSON.parse(root.querySelector('[data-vipr-catalog]').textContent); } catch (e) { catalog = []; }
      catalog.forEach(function (sport) {
        sport.tires.forEach(function (t) {
          var seen = {};
          t.s = t.s.filter(function (s) { if (!s || s === 'Default Title' || seen[s]) return false; seen[s] = 1; return true; });
        });
        sport.tires = sport.tires.filter(function (t) { return t.s.length; })
          .sort(function (a, b) { return a.t.localeCompare(b.t); });
      });

      var form = root.querySelector('[data-vipr-form]');
      var sportSel = root.querySelector('[data-vipr-sport]');
      var tireSel = root.querySelector('[data-vipr-tire]');
      var sizeSel = root.querySelector('[data-vipr-size]');
      var submit = root.querySelector('[data-vipr-submit]');
      var status = root.querySelector('[data-vipr-status]');
      var success = root.querySelector('[data-vipr-success]');
      var summary = root.querySelector('[data-vipr-summary]');
      var buttonLabel = submit.textContent;

      function reset(sel, text) {
        while (sel.options.length) sel.remove(0);
        sel.add(new Option(text, ''));
      }

      function fillTires() {
        var sport = catalog[sportSel.value];
        reset(tireSel, sport ? 'Select your tire' : 'Choose a motorsport first');
        reset(sizeSel, 'Choose a tire first');
        sizeSel.disabled = true;
        if (sport) sport.tires.forEach(function (t) { tireSel.add(new Option(t.t, t.h)); });
        tireSel.disabled = !sport || !sport.tires.length;
      }

      function currentTire() {
        var sport = catalog[sportSel.value];
        if (!sport) return null;
        for (var i = 0; i < sport.tires.length; i++) if (sport.tires[i].h === tireSel.value) return sport.tires[i];
        return null;
      }

      function fillSizes() {
        var tire = currentTire();
        reset(sizeSel, tire ? 'Select your size' : 'Choose a tire first');
        if (tire) tire.s.forEach(function (s) { sizeSel.add(new Option(s, s)); });
        sizeSel.disabled = !tire;
      }

      sportSel.addEventListener('change', fillTires);
      tireSel.addEventListener('change', fillSizes);

      // Pre-select from the link, e.g. ?sport=drift&tire=accelera-651-sport
      var params = new URLSearchParams(location.search);
      var wantSport = (params.get('sport') || '').toLowerCase();
      var wantTire = (params.get('tire') || '').toLowerCase();
      if (wantSport) {
        for (var i = 0; i < catalog.length; i++) {
          if (catalog[i].slug === wantSport || catalog[i].label.toLowerCase() === wantSport) { sportSel.value = String(i); fillTires(); break; }
        }
      }
      if (wantTire && !tireSel.disabled) {
        tireSel.value = wantTire;
        if (tireSel.value === wantTire) fillSizes(); else tireSel.value = '';
      }

      function invalid(el, bad) { if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); return bad; }

      function post(path, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(root.dataset.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': REVISION },
          body: JSON.stringify(body)
        });
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        status.textContent = '';
        var f = form.elements;
        if (f.company_website.value) return; // bot

        var email = f.email.value.trim();
        var first = f.first_name.value.trim();
        var tire = currentTire();
        var problems = [];
        if (invalid(f.first_name, !first)) problems.push('first name');
        if (invalid(f.email, !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email))) problems.push('a valid email');
        if (invalid(sportSel, !catalog[sportSel.value])) problems.push('your motorsport');
        if (invalid(tireSel, !tire)) problems.push('your tire');
        if (invalid(sizeSel, !tire || tire.s.indexOf(sizeSel.value) === -1)) problems.push('your size');
        if (!f.consent.checked) problems.push('the email consent box');
        if (problems.length) { status.textContent = 'Please add ' + problems.join(', ') + '.'; return; }
        if (!root.dataset.company || !root.dataset.list) { status.textContent = 'This form isn\'t connected yet. Please try again later.'; return; }

        var sport = catalog[sportSel.value].label;
        var props = {
          'Application': sport,
          'Tire Model Requested': tire.t,
          'Tire Product Handle': tire.h,
          'Tire Size Requested': sizeSel.value,
          'Additional Tire Sizes': f.additional_sizes.value.trim(),
          'Vehicle Details': f.vehicle.value.trim(),
          'Reservation Contact Phone': f.phone.value.trim(),
          'Reservation Source': root.dataset.source,
          'Reservation Page': location.origin + location.pathname,
          'UTM Source': params.get('utm_source') || '',
          'UTM Medium': params.get('utm_medium') || '',
          'UTM Campaign': params.get('utm_campaign') || '',
          'UTM Content': params.get('utm_content') || '',
          'From Meta Ad': params.has('fbclid') ? 'Yes' : 'No'
        };
        var profile = { email: email, first_name: first };
        if (f.last_name.value.trim()) profile.last_name = f.last_name.value.trim();

        var subProfile = JSON.parse(JSON.stringify(profile));
        subProfile.properties = props;

        submit.disabled = true;
        submit.textContent = 'Submitting...';

        post('subscriptions', {
          data: { type: 'subscription', attributes: { custom_source: root.dataset.source, profile: { data: { type: 'profile', attributes: subProfile } } },
            relationships: { list: { data: { type: 'list', id: root.dataset.list } } } }
        }).then(function (res) {
          if (!res.ok) throw new Error('subscribe ' + res.status);
          return post('events', {
            data: { type: 'event', attributes: { properties: props,
              metric: { data: { type: 'metric', attributes: { name: root.dataset.metric } } },
              profile: { data: { type: 'profile', attributes: profile } } } }
          }).catch(function () {});
        }).then(function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'vip_reservation_submit', application: sport, tire: tire.t, tire_size: sizeSel.value });
                    if (window.fbq) window.fbq('track', 'Lead', { content_name: 'VIP Tire Size Sign-Up', content_category: sport });
          summary.textContent = sport + ' · ' + tire.t + ' · ' + sizeSel.value;
          form.hidden = true;
          success.hidden = false;
          success.focus();
        }).catch(function () {
          status.textContent = 'Something went wrong. Please try again in a moment.';
          submit.disabled = false;
          submit.textContent = buttonLabel;
        });
      });
    }

    function run() { document.querySelectorAll('section.vipr').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
